"use client";

import { IDiscoverPageAIContentResponse } from "@faire/web-api--source/indigofair/seo/IDiscoverPageAIContentResponse";
import { createContext, useContext } from "react";

export const DiscoverPageAIContentPromiseContext = createContext<
  Promise<IDiscoverPageAIContentResponse> | undefined
>(undefined);

export const DiscoverPageAIContentPromiseContextProvider = ({
  children,
  aiContentPromise,
}: {
  children: React.ReactNode;
  aiContentPromise: Promise<IDiscoverPageAIContentResponse>;
}) => {
  return (
    <DiscoverPageAIContentPromiseContext.Provider value={aiContentPromise}>
      {children}
    </DiscoverPageAIContentPromiseContext.Provider>
  );
};

export const useDiscoverPageAIContentPromise = () => {
  return useContext(DiscoverPageAIContentPromiseContext);
};
